import http from '@/request/index'
const shopBaseUrl =
  http.curEv() == 'pro'
    ? 'https://shop.gymcity.com.cn'
    : 'https://tshop.gymcity.com.cn'
export { shopBaseUrl }
